// import { useEffect } from "react";
// import { useLocation } from "react-router-dom";

// export const RedirectPDF = () => {
//   const { pathname } = useLocation();

//   useEffect(() => {
//     const filePath = pathname.replace("/pdf/", "");

//     window.location.replace(
//       `https://q-care-space.ams3.digitaloceanspaces.com/pdf/${filePath}`
//     );
//   }, [pathname]);

//   return null;
// }

import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

const BUCKET_PDF_BASE =
  "https://q-care-space.ams3.digitaloceanspaces.com/pdf/";

// Report PDFs are stored under keys shaped like:
//   pdf/YYYY/MM/DD-MM-<timestamp>_<sanitizedName>.pdf
// (see server/src/services/uploadToSpaces.ts → uploadPDFReport). We only ever
// redirect to that shape. Reject anything else to prevent path traversal
// (../) or redirects to arbitrary bucket keys / crafted paths.
const SAFE_PDF_PATH = /^[A-Za-z0-9._/-]+\.pdf$/;

const isSafePdfPath = (path: string): boolean =>
  SAFE_PDF_PATH.test(path) && !path.includes("..");

export const RedirectPDF = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const filePath = pathname.replace(/^\/pdf\//, "");

    if (!isSafePdfPath(filePath)) {
      // Malformed / suspicious path — do not redirect to the bucket.
      navigate("/", { replace: true });
      return;
    }

    window.location.replace(`${BUCKET_PDF_BASE}${filePath}`);
  }, [pathname, navigate]);

  return null;
};
